var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.6667)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9 3.748 3-3 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 20.248-3 3-3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 0.748v22.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.75 14.998-3-3 3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.25 8.998 3 3-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.75 11.998h22.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.34616400.svg";
export { ForwardRef as ReactComponent };